module.exports = __webpack_public_path__ + "static/media/MTA-Software-Development-Fundamentals-2018.24e68ab5.png";